import React, { useEffect, useState, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useParams } from 'react-router-dom';
import matter from 'gray-matter';
import { Helmet } from 'react-helmet';
import { notify } from '../services/notify';
// import { logEvent, saveDesiteEventInDB } from './tracking.js';
import axios from 'axios';
import { Link } from 'react-router-dom';

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

export function PageList() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
      // Carregar o arquivo JSON com as páginas
      axios.get('/filesIndex.json')
          .then(response => {
              setPages(response.data);
          })
          .catch(error => {
              console.error('Erro ao carregar o índice:', error);
          });
  }, []);

  return (
    <section className="section">
    <div className="content-container-single-column">
        <h1>Dúvidas respondidas de circuitos elétricos</h1>
        <h3>Leia também:</h3><ul><li><a href="/answer/02133-como-funciona-um-oscilador-de-ponte-de-wien-em-circuitos-analogicos">Como funciona um oscilador de ponte de Wien em circuitos analógicos?</a></li><li><a href="/answer/03227-como-funcionam-os-amplificadores-em-circuitos-eletricos">Como Funcionam os Amplificadores em Circuitos Elétricos?</a></li><li><a href="/answer/00622-como-os-mapas-de-karnaugh-simplificam-funcoes-logicas-em-circuitos-digitais">Como os Mapas de Karnaugh Simplificam Funções Lógicas em Circuitos Digitais?</a></li><li><a href="/answer/02024-como-funciona-a-juncao-pn-em-semicondutores">Como Funciona a Junção PN em Semicondutores?</a></li><li><a href="/answer/00521-como-calcular-a-impedancia-equivalente-em-circuitos-de-corrente-alternada">Como calcular a impedância equivalente em circuitos de corrente alternada?</a></li><li><a href="/answer/00751-o-que-e-a-resposta-impulsiva-de-um-circuito-eletrico">O que é a resposta impulsiva de um circuito elétrico?</a></li><li><a href="/answer/03041-como-a-analise-de-circuitos-em-corrente-alternada-e-realizada">Como a Análise de Circuitos em Corrente Alternada é Realizada?</a></li><li><a href="/answer/01954-o-que-e-um-latch-em-circuitos-digitais">O que é um Latch em Circuitos Digitais?</a></li><li><a href="/answer/01836-o-que-e-um-circuito-aberto-e-como-ele-afeta-a-corrente-eletrica">O que é um circuito aberto e como ele afeta a corrente elétrica?</a></li><li><a href="/answer/03542-como-a-analise-de-supermalha-facilita-a-resolucao-de-circuitos-complexos">Como a Análise de Supermalha Facilita a Resolução de Circuitos Complexos?</a></li></ul>
    </div>
    </section>
  );
}

export function FilteredPageList({ count }) {
  const [filteredPages, setFilteredPages] = useState([]);

  function getRandomNumbers(count) {
    const maxNumber = 999; // Máximo de 299 para sorteio
    const numbers = new Set();

    while (numbers.size < count) {
        const randomNum = Math.floor(Math.random() * (maxNumber + 1))
            .toString()
            .padStart(5, '0'); // Preenche com zeros à esquerda
        numbers.add(randomNum);
    }
    return Array.from(numbers);
  }

  const numbers = useMemo(() => getRandomNumbers(count), [count]);

  useEffect(() => {
      axios.get('/filesIndex.json')
          .then(response => {
              const allPages = response.data;

              const filtered = allPages.filter(page =>
                  numbers.includes(page.number.toString().padStart(5, '0'))
              );

              setFilteredPages(filtered);
          })
          .catch(error => {
              console.error('Erro ao carregar o índice:', error);
          });
  }, [numbers]);

  return (
      <div>
          <h1>Sugestões de outras explicações de circuitos elétricos:</h1>
          <ul>
              {filteredPages.map(page => (
                  <li key={page.number}>
                      <Link to={`/answer/${page.filename.replace('.md', '')}`}>
                          {page.title}
                      </Link>
                  </li>
              ))}
          </ul>
          <Link to={`/anslist`}>
          Lista de todas as explicações
          </Link>
      </div>
  );
}

export function KnowCourseFromBlogButton({ buttonName }) {
  const handleClick = () => {
      // Push the data to the dataLayer when the button is clicked
      window.dataLayer.push({
          event: 'clickFromBlog', // Custom event name
          buttonName: 'clickFromBlog', // Custom event data, you can adjust this as needed
      });
      notify("CLIQUE DE POST", "Alguém acessou um answer_post e clicou no botão para SignUp!");
      // logEvent('ButtonClick', `${buttonName} clicked`);
      // saveDesiteEventInDB("blog_click", utmTags.v);
      // Redirect the user after pushing the data to GTM if needed
      window.location.href = '#form'; // Redirect to the form anchor
  };

  return (
      <button className="btn-inscricao" onClick={handleClick}>
          Começar a estudar gratuitamente
      </button>
  );
}

export const AnswerText = () => {
  const { postId } = useParams();
  const [content, setContent] = useState('');
  const [metadata, setMetadata] = useState({});

  useEffect(() => {
    import(`../../public/posts/${postId}.md`)
      .then(res => fetch(res.default))
      .then(res => res.text())
      .then(text => {
        const { data, content } = matter(text);
        setMetadata(data);
        setContent(content);
      })
      .catch(err => console.log(err));
  }, [postId]);

  return (
    <section className="section">
      <div className="content-container-single-column">
        <Helmet>
          <title>{metadata.title}</title>
          <meta name="description" content={metadata.description} />
          <meta name="keywords" content={metadata.keywords} />
        </Helmet>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {content}
        </ReactMarkdown>
        <h3><b>Para estudar circuitos elétricos com aulas em vídeo do Prof. Nicholas Yukio, clique no botão abaixo para criar uma conta gratuita no nosso site:</b></h3>
        <KnowCourseFromBlogButton buttonName="BlogButton" />
        <FilteredPageList count={10} />
      </div>
    </section>
  );
};
